(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      window.addEventListener('resize', this.onResizeHandler);

      this.header.querySelectorAll('.bulkx-header__menu-item--has-mega').forEach((item) => {
  item.addEventListener('mouseenter', () => this.setHeaderHeight());
  item.addEventListener('focusin', () => this.setHeaderHeight());
});

      this.createObserver();
    }

setHeaderHeight() {
  if (!this.header) return;

  const headerHeight = this.header.offsetHeight;
  const megaAnchor = this.header.querySelector('.bulkx-header__sub-wrap') || this.header.querySelector('.bulkx-header') || this.header;
  const megaTop = megaAnchor.getBoundingClientRect().bottom;

  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  document.documentElement.style.setProperty('--bulkx-mega-top', `${Math.max(megaTop, 0)}px`);
}

disconnectedCallback() {
  window.removeEventListener('scroll', this.onScrollHandler);
  window.removeEventListener('resize', this.onResizeHandler);
}

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      if (this.headerIsAlwaysSticky) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }

      this.currentScrollTop = scrollTop;
      this.setHeaderHeight();
    }
  }

  document.addEventListener('click', function(event) {
  const localeButton = event.target.closest('.bulkx-header__locale-button');
  const localeLists = document.querySelectorAll('.bulkx-header__locale-list');

  if (localeButton) {
    const wrapper = localeButton.closest('.bulkx-header__locale-disclosure');
    const list = wrapper.querySelector('.bulkx-header__locale-list');
    const isOpen = !list.hasAttribute('hidden');

    localeLists.forEach((openList) => {
      openList.setAttribute('hidden', '');
      const openButton = openList.closest('.bulkx-header__locale-disclosure')?.querySelector('.bulkx-header__locale-button');
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      list.removeAttribute('hidden');
      localeButton.setAttribute('aria-expanded', 'true');
    }

    return;
  }

  if (!event.target.closest('.bulkx-header__locale-disclosure')) {
    localeLists.forEach((list) => {
      list.setAttribute('hidden', '');
      const button = list.closest('.bulkx-header__locale-disclosure')?.querySelector('.bulkx-header__locale-button');
      if (button) button.setAttribute('aria-expanded', 'false');
    });
  }
});

  document.querySelectorAll('[data-bulkx-mobile-drawer]').forEach((drawer) => {
    const toggle = drawer.querySelector('[data-bulkx-drawer-toggle]');
    const panel = drawer.querySelector('.bulkx-header__drawer-panel');
    const closeButtons = drawer.querySelectorAll('[data-bulkx-drawer-close]');
    const drawerLinks = drawer.querySelectorAll(
      '.bulkx-header__drawer-link, .bulkx-header__drawer-mega-link, .bulkx-header__drawer-mega-all, a.bulkx-header__drawer-mega-promo, .bulkx-header__logo-link'
    );

    const syncDrawerState = () => {
      const isOpen = drawer.hasAttribute('open');
      toggle?.setAttribute('aria-expanded', String(isOpen));
      panel?.setAttribute('aria-hidden', String(!isOpen));
      document.documentElement.classList.toggle('bulkx-mobile-drawer-open', isOpen);
    };

    const closeDrawer = (focusToggle = false) => {
      drawer.removeAttribute('open');
      syncDrawerState();
      if (focusToggle) toggle?.focus();
    };

    drawer.addEventListener('toggle', syncDrawerState);

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closeDrawer(true));
    });

    drawerLinks.forEach((link) => {
      link.addEventListener('click', () => {
        const href = link.getAttribute('href');
        if (!href || href === '#') return;
        closeDrawer(false);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.hasAttribute('open')) {
        closeDrawer(true);
      }
    });

    syncDrawerState();
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
